import { del, get, put, post, upload } from '@api/request';

export async function fetchPricingSchedules(
  { appraisalService },
  authenticationToken,
  { year, sortField, sortDirection, page = 1, pageSize = 25, filters = {} },
) {
  let url = `${appraisalService}/appraisal/incomepricingschedules?incomeYr=${year}`;
  url += `&page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      url += `&${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`;
    }
  });
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPricingSchedule(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/appraisal/incomepricingschedules`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  let url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function downloadPricingScheduleFile(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, s3ID },
) {
  const url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function insertPricingScheduleFile(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, payload },
) {
  const url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deletePricingScheduleFile(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, s3ID, payload },
) {
  let url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updatePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, data },
) {
  const url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updatePricingScheduleTags(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, tags },
) {
  const url = `${appraisalService}/appraisal/incomepricingschedule/${pricingScheduleId}/tags`;
  const { body } = await put(authenticationToken, url, { tags });
  return body;
}

export async function fetchCodeFile(
  { appraisalService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGprAdjTypes(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/incomepricingschedule/gprAdjType`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExpenseTypes(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/incomepricingschedule/expenseType`;
  const { body } = await get(authenticationToken, url);
  return body;
}
